module.exports = __webpack_public_path__ + "img/home_menu_4_selected.36ccd43b.png";